import React, { useState, useRef, useEffect } from "react";
import { Navigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { alertActions } from "../_actions";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import SignatureCanvas from "react-signature-canvas";
import { styled } from "@mui/material/styles";
import { FaBars } from "react-icons/fa";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/fr.js";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import axios from "axios";
import { FaFileSignature } from "react-icons/fa";
import { CiText } from "react-icons/ci";
import { FaCalendarDays } from "react-icons/fa6";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { Resizable } from "re-resizable";
import Draggable from "react-draggable";
import { FaCog } from "react-icons/fa";
import { BiExpandAlt } from "react-icons/bi";
import { FaTextWidth } from "react-icons/fa";
import { CiShare1 } from "react-icons/ci";
import { FaRegCopy } from "react-icons/fa";
import { CiTimer } from "react-icons/ci";
import { IoPrintOutline } from "react-icons/io5";
import { AiOutlineCloudDownload } from "react-icons/ai";

import PizZip from "pizzip";
import { Docxtemplater } from "docxtemplater";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import Layout from "./Layout";
import EsignModal from "../components/eSignModal";
import DemoGuide from "../component/modals/demoGuide";
import ShareDocumentModal from "../component/modals/shareDocumentModal";
import FileViewer from "react-file-viewer";
import download from "downloadjs";
import { Document, Page, pdfjs } from "react-pdf";
import ReactFileViewer from "react-file-viewer";
import ActionModal from "../components/ActionModal";
import SignerDialog from "../components/signaturePartnerModal";
import { CircularProgress } from "@mui/material";
// Set the workerSrc for pdfjs
pdfjs.GlobalWorkerOptions.workerSrc =
  "https://unpkg.com/pdfjs-dist@2.12.313/build/pdf.worker.min.js"; // Ensure the worker script is correctly set

const SignerDesDocuments = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(null);
  const [isEditing, setIsEditing] = useState(false); // State to toggle between view and edit mode
  const [filePreview, setFilePreview] = useState(null); // State to store the signature preview
  const sigPad = useRef(null);
  const dispatch = useDispatch();
  const [popupPosition, setPopupPosition] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [isNext, setIsNext] = useState(false);
  const [activeInput, setActiveInput] = useState(null);
  const [inputs, setInputs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [isActionOpen, setIsActionOpen] = useState(false);
  const [isDemoOpen, setIsDemoOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [docId, setDocId] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [signatureImage, setSignatureImage] = useState(null);
  const [fileType, setFileType] = useState("");
  const [signatureUserModal, setSignatureUserModal] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const [currentSigner, setCurrentSigner] = useState(null);
  const handleNext = () => {
    setIsNext(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    // Check if there's a document_key in the URL when component mounts
    const urlParams = new URLSearchParams(window.location.search);
    const documentKey = urlParams.get("document_key");
    console.log("documentKey first", documentKey);
    if (documentKey) {
      fetchDocumentByKey(documentKey);
    }
    // get-document-by-document-key
  }, []);

  const fetchDocumentByKey = async (documentKey) => {
    try {
      console.log("documentKey call", documentKey);
      setIsLoading(true);
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_URL
        }api/prouser/get-document-by-document-key/${
          documentKey ? documentKey : ""
        }`
      );
      console.log("response", response);
      if (response.status === 200 && response.data.success) {
        setDocId(response.data.data.id);
        // Convert the Base64 string to a Blob
        const byteCharacters = atob(response.data.data.file_attachment); // Decode the Base64 string
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
          const slice = byteCharacters.slice(offset, offset + 1024);
          const byteNumbers = new Array(slice.length);

          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: "application/pdf" });
        setSelectedFile(blob);
        setFileType("pdf");
        setSelectedFile(blob);
        setFile(URL.createObjectURL(blob));
        setDocumentData(response?.data?.documentData);
        setIsLoading(false);
        // Create a URL for the Blob and set it to the state
        // setFile(URL.createObjectURL(blob));

        // setIsDemoOpen(true);
        // setSelectedFile(blob);
        // setFilePreview(response?.data?.filename);
        // setFileType(fileType);
        // Create a URL for the Blob and set it to the state
        // setFile(URL.createObjectURL(blob));
      }
    } catch (err) {
      console.log("Error fetching dossiers", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePdfClick = (pageIndex, e) => {
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left; // X position of click
    const y = e.clientY - rect.top; // Y position of click
    const position = {
      x: x,
      y: y,
      pageIndex: pageIndex,
    };
    if (isEditing) {
      // Store click position for the specific page
      // const newClickPositions = [...popupPosition];
      // newClickPositions[pageIndex] = { x, y };
      setPopupPosition(position);
      setShowPopup(true);
    }
  };

  const handleToolClick = (type) => {
    setShowPopup(false);
    setSignatureUserModal(true);
    // const viewer = document.querySelector(".rpv-core__viewer");
    // if (!viewer) return;
    const pos = {
      x: popupPosition.x < 139 ? popupPosition.x + 135 : popupPosition.x,
      // y: popupPosition.y + popupPosition.pageIndex * 870,
      y:
        fileType === "doc" || fileType === "docx"
          ? popupPosition.y +
            popupPosition.pageIndex * 800 -
            popupPosition.pageIndex * (popupPosition.pageIndex < 4 ? 15 : 10)
          : popupPosition.y + popupPosition.pageIndex * 870,
    };
    const newInput = {
      id: Date.now(),
      type,
      position: pos,
      y: popupPosition.y,
      x: popupPosition.x,
      content: type === "date" ? dayjs(new Date()) : "",
      size: { width: 200, height: 40 },
      pageIndex: popupPosition.pageIndex,
      signaturePerter: "",
      parterName: "",
      parterEmail: "",
      partnerId: "",
    };
    setInputs([...inputs, newInput]);
    setActiveInput(newInput.id);
  };

  const currentUser = useSelector((state) => state.authentication.user);
  if (!currentUser) {
    return <Navigate to="/" />;
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.name.split(".").pop().toLowerCase();
      if (!["pdf", "doc", "docx"].includes(fileType)) {
        setUploadError("Seuls les fichiers PDF, DOC et DOCX sont acceptés");
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        setUploadError("La taille du fichier ne doit pas dépasser 10MB");
        return;
      }

      setUploadProgress(10);

      let fileToDisplay = file;
      let displayType = fileType;
      let displayUrl = null;

      // Convert DOC/DOCX to PDF only for display purposes
      // if (fileType === "doc" || fileType === "docx") {
      //   try {
      //     setUploadProgress(15);
      //     // Read the file
      //     const reader = new FileReader();
      //     const fileData = await new Promise((resolve, reject) => {
      //       reader.onload = () => resolve(reader.result);
      //       reader.onerror = reject;
      //       reader.readAsArrayBuffer(file);
      //     });

      //     setUploadProgress(25);

      //     // Convert to HTML using mammoth.js
      //     let result;
      //     let conversionSuccessful = true;

      //     try {
      //       result = await mammoth.convertToHtml({ arrayBuffer: fileData });

      //       // Check if the conversion seems valid
      //       if (!result || !result.value || result.value.trim() === '' || result.value.length < 50) {
      //         conversionSuccessful = false;
      //       }
      //     } catch (error) {
      //       console.error("Document conversion failed:", error);
      //       conversionSuccessful = false;
      //     }

      //     // If conversion successful, create PDF for display only
      //     if (conversionSuccessful) {
      //       setUploadProgress(50);

      //       // Convert HTML to PDF using html2pdf
      //       const options = {
      //         margin: 10,
      //         filename: `${file.name.replace(/\.[^/.]+$/, "")}.pdf`,
      //         image: { type: 'jpeg', quality: 0.98 },
      //         html2canvas: { scale: 2 },
      //         jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      //       };

      //       // Create HTML container
      //       const container = document.createElement('div');
      //       container.innerHTML = result.value;
      //       document.body.appendChild(container);

      //       // Convert to PDF for display only
      //       const pdfBlob = await html2pdf().from(container).set(options).outputPdf('blob');
      //       document.body.removeChild(container);

      //       setUploadProgress(75);

      //       // Store the display file separately
      //       fileToDisplay = pdfBlob;
      //       displayType = "pdf";
      //       displayUrl = URL.createObjectURL(pdfBlob);
      //     } else {
      //       // If conversion failed, just use the original file for display
      //       alert("La conversion pour l'affichage n'a pas réussi. Le document sera affiché dans son format d'origine.");
      //     }
      //   } catch (error) {
      //     console.error("Error in display conversion:", error);
      //     // Continue with original file if display conversion fails
      //   }
      // }

      // Always send the original file to the backend
      const formData = new FormData();
      formData.append("user_id", currentUser.data.id);
      formData.append("pdf", file); // Send original file to backend
      formData.append("original_type", fileType); // Save original file type

      let startTime = Date.now();
      try {
        setIsLoading(true);
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}api/prouser/esign-des-documents`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              // Calculate the percentage progress based on file size
              const totalSize = progressEvent.total;
              const loaded = progressEvent.loaded;

              // Calculate percentage completed (0 to 100%)
              const percentCompleted = Math.round((loaded * 100) / totalSize);

              let startProgress = 75; // Start progress from 75 since we already did some processing
              const targetProgress = 100; // End progress
              const duration = 1500; // 1.5 seconds in milliseconds
              const stepTime = 100; // Time between each step (milliseconds)
              const steps = duration / stepTime; // Number of steps in the duration
              const stepProgress = (targetProgress - startProgress) / steps; // Progress increment per step

              // Gradually increase progress
              let currentProgress = startProgress;

              const interval = setInterval(() => {
                currentProgress += stepProgress;
                if (currentProgress >= percentCompleted) {
                  currentProgress = percentCompleted;
                  clearInterval(interval); // Stop once the target is reached
                }
                setUploadProgress(Math.round(currentProgress)); // Update the progress state
              }, stepTime);
            },
          }
        );
        if (response.status === 200 && response.data.success) {
          setDocId(response.data.id);
          const byteCharacters = atob(response.data.file_attachment); // Decode the Base64 string
          const byteArrays = [];
          if (response?.data?.documentData?.document_key) {
            const documentKey = response.data.documentData.document_key;
            // Update URL without refreshing the page
            const url = new URL(window.location);
            url.searchParams.set("document_key", documentKey);
            window.history.pushState({}, "", url);
          }
          for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
            const slice = byteCharacters.slice(offset, offset + 1024);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }

          const blob = new Blob(byteArrays, { type: "application/pdf" });
          setIsDemoOpen(true);
          setFilePreview(response?.data?.filename);

          // Set the file type for the UI to handle display appropriately
          setFileType(displayType);

          // Use the display file (converted to PDF) for the UI if available
          // if (displayUrl) {
          //   setSelectedFile(fileToDisplay);
          //   setFile(displayUrl);
          // } else {
          setSelectedFile(blob);
          setFile(URL.createObjectURL(blob));
          setDocumentData(response?.data?.documentData);
          setIsLoading(false);
          // }

          // Store the original file type for future reference (when updating)
          sessionStorage.setItem(`originalType_${response.data.id}`, fileType);
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        setUploadError(
          "Erreur lors de l'upload du fichier. Veuillez réessayer."
        );
        setUploadProgress(0);
      }
    }
  };
  const uploadFile = async (user) => {
    setUploading(true);
    setUploadError(null);
    setUploadSuccess(false);
    setUploadProgress(0);
    setTimeRemaining(null);

    try {
      // Convert signature canvas to blob
      // const signatureDataUrl = sigPad.current.toDataURL('image/png');
      const signatureBlob = await fetch(signatureImage).then((res) =>
        res.blob()
      );
      if (!selectedFile) {
        alert("Please upload a PDF first!");
        return;
      }

      const pdfDocClone = await PDFDocument.load(
        await selectedFile.arrayBuffer()
      );
      const helveticaFont = await pdfDocClone.embedFont(
        StandardFonts.Helvetica
      );

      const pages = pdfDocClone.getPages();

      // Loop through inputs to add text, date, or signature
      for (const input of inputs) {
        if(input.partnerId !== currentUser.data.id){
          continue;
        }
        const { type, position, content, size, pageIndex } = input;
        const pageIdx = pageIndex || 0;
        const page = pages[pageIdx];
        const x = input.x;
        const y = page.getHeight() - input.y; // invert y
        if (type === "text" || type === "date") {
          page.drawText(
            type === "date" ? dayjs(content).format("DD/MM/YYYY") : content,
            {
              x,
              y,
              size: 14,
              font: helveticaFont,
            }
          );
        } else if (type === "signature") {
          // Capture the signature from sigPad as Data URL
          const signatureBlob = await fetch(signatureImage).then((res) =>
            res.blob()
          );
          const signatureArrayBuffer = await signatureBlob.arrayBuffer();
          const signatureImageEmbed = await pdfDocClone.embedPng(
            signatureArrayBuffer
          );

          page.drawImage(signatureImageEmbed, {
            x,
            y: y - (size?.height || 40), // adjust for image height
            width: 50,
            height: size?.height || 40,
          });
        }
      }

      const pdfBytes = await pdfDocClone.save();

      const formData = new FormData();
      formData.append("user_id", currentUser.data.id);
      formData.append("document_id", docId);
      // formData.append("signature", signatureFile);
      // Check if selectedFile is a Blob and handle it appropriately
      if (selectedFile instanceof Blob) {
        // Create a proper PDF file from the Blob with appropriate naming
        const pdfFile = new File(
          [pdfBytes],
          pdfBytes.name || `document-${Date.now()}.pdf`,
          { type: "application/pdf" }
        );
        formData.append("pdf", pdfFile);
      } else {
        // If it's already a File or other format, append as is
        formData.append("pdf", pdfBytes);
      }
      formData.append("position", JSON.stringify(inputs));
      formData.append("fileType", fileType); // Send file type to backend

      let startTime = Date.now();
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}api/prouser/update-document`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          // onUploadProgress: (progressEvent) => {
          //   const percentCompleted = Math.round(
          //     (progressEvent.loaded * 100) / progressEvent.total
          //   );
          // setUploadProgress(percentCompleted);

          // const timeElapsed = Date.now() - startTime;
          // const uploadSpeed = progressEvent.loaded / (timeElapsed / 1000);
          // const remainingBytes = progressEvent.total - progressEvent.loaded;
          // const estimatedTimeRemaining = remainingBytes / uploadSpeed;
          // setTimeRemaining(estimatedTimeRemaining.toFixed(2));
          // },
        }
      );
      if (response.status === 200) {
        setUploadSuccess(response?.data?.message);
        // setFile(null);
        dispatch(alertActions.success(response?.data?.message));
        // sigPad.current.clear();
        setSignatureImage(null);
        setUploadError(null);
      } else {
        setUploadError(
          "Erreur lors du téléchargement du fichier. Veuillez réessayer."
        );
      }
    } catch (error) {
      console.error("Upload error:", error);
      setUploadError(
        "Erreur lors du téléchargement du fichier. Veuillez réessayer."
      );
    } finally {
      setUploading(false);
    }
  };

  const handleDragStop = (id, e, data) => {
    const { x, y } = data;
    setInputs(
      inputs.map((input) =>
        input.id === id ? { ...input, position: { x, y } } : input
      )
    );
  };

  const handleResize = (id, direction, ref, d) => {
    setInputs(
      inputs.map((input) =>
        input.id === id
          ? {
              ...input,
              size: {
                width: input.size.width + d.width,
                height: input.size.height + d.height,
              },
            }
          : input
      )
    );
  };

  const handleInputChange = (id, value) => {
    setInputs(
      inputs.map((input) =>
        input.id === id ? { ...input, content: value } : input
      )
    );
  };

  const handleEditPdf = async () => {
    if (!file) {
      alert("Veuillez sélectionner un fichier PDF..");
      return;
    }

    if (!sigPad.current || sigPad.current.isEmpty()) {
      alert("Veuillez signer le document avant de le modifier.");
      return;
    }

    // Load the selected PDF
    const existingPdfBytes = await fetch(file).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const page = pdfDoc.getPages()[0];

    // Get signature data as DataURL
    const signatureDataUrl = sigPad.current.toDataURL("image/png");

    if (!signatureDataUrl || signatureDataUrl === "data:,") {
      alert("La signature est vide. Veuillez signer le document.");
      return;
    }

    // Convert the signature DataURL to a Blob
    const signatureBlob = await fetch(signatureDataUrl).then((res) =>
      res.blob()
    );
    const signatureArrayBuffer = await signatureBlob.arrayBuffer();
    const signatureUint8Array = new Uint8Array(signatureArrayBuffer);

    setSignatureImage(signatureDataUrl);
    uploadFile("currentUser")
    // handleCloseModal();
  };
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[200],
      ...theme.applyStyles("dark", {
        backgroundColor: theme.palette.grey[800],
      }),
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      background: "linear-gradient(94.46deg, #27295B 0%, #1CBE93 110.28%)", // Add the gradient here
      ...theme.applyStyles("dark", {
        background: "linear-gradient(94.46deg, #27295B 0%, #1CBE93 110.28%)", // Add the gradient here for dark mode
      }),
    },
  }));
  dayjs.locale("fr");
  return (
    <Layout>
      <div className="mb-8 col-span-12 xl:col-span-9">
        <div className="xl:max-w-[1126px] w-full h-full bg-white md:rounded-[20px]">
          <div className="mainHead min-h-[80px] sm:min-h-[120px] flex sm:flex-row flex-col sm:items-center p-3 sm:p-10 sm:justify-between">
            <h1 className="text-lg sm:text-xl md:text-lg xl:text-xl 2xl:text-xl font-extrabold text-white sm:mt-0 mt-4">
              Signer des documents
            </h1>
            <div className="flex gap-4">
              <Link to="/prouser/esign-des-documents">
                <button className="bg-primary text-white py-2 px-4 rounded">
                  Listes de documents
                </button>
              </Link>
              {/* <button
                className="bg-green-500 text-white py-2 px-4 rounded"
                onClick={toggleEditMode}
              >
                {isEditing ? "Exit Edit Mode" : "Edit PDF"}
              </button> */}
            </div>
          </div>
          <div className="p-6 flex flex-col items-center">
            {/* <div style={{ width: "75%" }} className="flex direction-row my-4">
                    <BorderLinearProgress  variant="determinate" value={75} />
                    </div> */}
            <div className="w-full max-w-4xl mx-auto">
              <div
                className="mb-8 relative  flex justify-center  flex-col"
                style={{ height: "auto" }}
              >
                <h2 className="text-2xl font-bold text-center mb-4">
                  Signer des documents
                </h2>
                <p className="text-gray-600 text-center mb-12">
                  Conservez des documents en toute sécurité et signez en ligne
                </p>
                {/* <BorderLinearProgress variant="determinate" value={50} /> */}
                {uploadProgress > 0 && !file ? (
                  <div style={{ width: "75%" }} className=" mx-auto">
                    <BorderLinearProgress
                      variant="determinate"
                      value={uploadProgress}
                    />
                    {isLoading && (
                      <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                        <CircularProgress />
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
              {file && !isNext && (
                <button
                  className="items-center gap-2 bg-secondary text-white px-6 py-2 mb-2 h-10 rounded hover:bg-primary flex self-end ml-auto mr-40"
                  onClick={() => setIsActionOpen(true)}
                >
                  <FaBars />
                  Actions
                </button>
              )}
            </div>
            {(() => {
              if (file && file !== "") {
                return (
                  <div className="w-full max-w-4xl mx-auto">
                    <div className="mb-8 relative" style={{ height: "auto" }}>
                      {/* <Worker
                        workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}
                      > */}
                      <div
                        // onClick={handlePdfClick}
                        className="relative h-full"
                      >
                        {/* <Viewer fileUrl={file} /> */}
                        {fileType === "pdf" ||
                        fileType === "doc" ||
                        fileType === "docx" ? (
                          // <Worker
                          //   workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}
                          // >
                          //   <Viewer fileUrl={file} />
                          // </Worker>
                          <Document
                            file={file}
                            onLoadSuccess={({ numPages }) =>
                              setNumPages(numPages)
                            } // Set total number of pages
                            onLoadError={(error) =>
                              console.error("Error loading PDF:", error)
                            }
                          >
                            {/* Render each page dynamically */}
                            {Array.from(new Array(numPages), (el, index) => (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Page
                                  pageNumber={index + 1}
                                  width={600}
                                  height={700}
                                  className="mb-4 shadow-lg"
                                  onClick={(e) => handlePdfClick(index, e)}
                                />
                                {/*  */}
                              </div>
                            ))}
                          </Document>
                        ) : fileType === "doc" || fileType === "docx" ? (
                          // <FileViewer
                          //   fileType={fileType}
                          //   filePath={file}
                          // />
                          // <Worker
                          //   workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}
                          // >
                          <Worker
                            workerUrl={`${process.env.PUBLIC_URL}/pdf.worker.min.js`}
                          >
                            <div
                              className="relative h-full"
                              onClick={(e) => handlePdfClick(0, e)}
                            >
                              <ReactFileViewer
                                fileType={fileType}
                                filePath={file}
                                onError={(e) =>
                                  console.log("FileViewer error:", e)
                                }
                              />
                            </div>
                          </Worker>
                        ) : null}
                      </div>
                      {showPopup && !isNext && (
                        <div
                          className="absolute bg-[#fff] rounded-lg shadow-lg border border-gray-600 flex gap-[0.08rem] overflow-hidden"
                          style={{
                            left: `${
                              popupPosition.x < 139
                                ? popupPosition.x + 135
                                : popupPosition.x
                            }px`,
                            top: `${
                              fileType === "doc" || fileType === "docx"
                                ? popupPosition.y +
                                  popupPosition.pageIndex * 800 -
                                  popupPosition.pageIndex *
                                    (popupPosition.pageIndex < 4 ? 15 : 10)
                                : popupPosition.y +
                                  popupPosition.pageIndex * 870
                            }px`,
                            // zIndex: 1000,
                          }}
                        >
                          <button
                            onClick={() => handleToolClick("signature")}
                            className="text-white bg-[#333] hover:bg-gray-200 p-2 flex flex-col items-center"
                            title="Draw"
                          >
                            <FaFileSignature className="h-5 w-5" />
                          </button>
                          <button
                            onClick={() => handleToolClick("text")}
                            className="text-white bg-[#333] hover:bg-gray-200 p-2 flex flex-col items-center"
                            title="Text"
                          >
                            <CiText className="h-5 w-5" />
                          </button>
                          <button
                            onClick={() => handleToolClick("date")}
                            className="text-white bg-[#333] hover:bg-gray-200 p-2 flex flex-col items-center"
                            title="Calendar"
                          >
                            <FaCalendarDays className="h-5 w-5" />
                          </button>
                          <button
                            onClick={() => setShowPopup(false)}
                            className="text-white bg-[#333] hover:bg-gray-200 p-2 flex flex-col items-center"
                            title="Delete"
                          >
                            <RiDeleteBin5Fill className="h-5 w-5" />
                          </button>
                        </div>
                      )}

                      {inputs.map((input) => (
                        <Draggable
                          key={input.id}
                          defaultPosition={input.position}
                          position={null}
                          onStop={(e, data) =>
                            handleDragStop(input.id, e, data)
                          }
                          disabled={isNext}
                          handle=".drag-handle"
                        >
                          <div
                            style={{
                              position: "absolute",
                              transform: "translate(0, 0)",
                              top: 0,
                            }}
                            className="select-none"
                          >
                            <Resizable
                              size={{
                                width: input.size.width,
                                height: input.size.height,
                              }}
                              onResizeStop={(e, direction, ref, d) =>
                                handleResize(input.id, direction, ref, d)
                              }
                              minWidth={200}
                              minHeight={40}
                              handleStyles={{
                                bottomRight: {
                                  bottom: -4,
                                  right: -4,
                                  cursor: "se-resize",
                                },
                              }}
                              enable={isNext}
                              disabled={isNext}
                              handleComponent={{
                                bottomRight: (
                                  <div className="absolute bottom-[-8px] right-[-8px] w-4 h-4 cursor-se-resize">
                                    <BiExpandAlt className="text-gray-500" />
                                  </div>
                                ),
                              }}
                            >
                              <div
                                className={`relative border ${
                                  activeInput === input.id
                                    ? "border-orange-400"
                                    : "border-gray-300"
                                } bg-white`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setActiveInput(input.id);
                                }}
                              >
                                {/* Toolbar */}
                                {!isNext && (
                                  <div className="absolute -top-8 right-0 bg-[#333] rounded-t-lg flex items-center gap-1 px-2 py-1">
                                    <button
                                      className="text-white hover:text-gray-300 p-1"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                    >
                                      <FaCog className="w-4 h-4" />
                                    </button>
                                    <button
                                      className="text-white hover:text-gray-300 p-1"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setInputs(
                                          inputs.filter(
                                            (i) => i.id !== input.id
                                          )
                                        );
                                        setSignatureImage(null);
                                        setShowPopup(false);
                                        setIsNext(false);
                                        setActiveInput(null);
                                      }}
                                    >
                                      <RiDeleteBin5Fill className="w-4 h-4" />
                                    </button>
                                  </div>
                                )}

                                {/* Drag handle */}
                                {!isNext && (
                                  <div className="drag-handle absolute top-0 left-0 w-full h-6 cursor-move bg-transparent" />
                                )}

                                {/* Content */}
                                <div className="p-2">
                                  {input.type === "text" && (
                                    <input
                                      type="text"
                                      value={input.content}
                                      onChange={(e) =>
                                        handleInputChange(
                                          input.id,
                                          e.target.value
                                        )
                                      }
                                      className="w-full outline-none text-gray-700 placeholder-gray-400"
                                      placeholder="Enter text"
                                    />
                                  )}
                                  {input.type === "date" && (
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DatePicker
                                        value={input.content}
                                        onChange={(e) =>
                                          handleInputChange(input.id, e)
                                        }
                                        disabled={!isNext}
                                        format="DD/MM/YYYY"
                                        // className="w-full outline-none text-gray-700"
                                        slotProps={{
                                          textField: {
                                            variant: "outlined",
                                            size: "small", // don't need this anymore so feel free to remove
                                            sx: {
                                              "> .MuiOutlinedInput-root": {
                                                height: 40, // whatever height you want here
                                                border: "none",
                                                width: "100%",
                                              },
                                              "> .MuiOutlinedInput-notchedOutline":
                                                {
                                                  border: "none",
                                                },
                                            },
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                  )}
                                  {input.type === "signature" &&
                                    (signatureImage ? (
                                      <img
                                        src={signatureImage}
                                        alt="Signature"
                                        className="w-full h-6 outline-none text-gray-700 placeholder-gray-400"
                                      />
                                    ) : (
                                      <button
                                        type="text"
                                        value={input.content}
                                        onClick={() => {
                                          if (isNext) {
                                            if (
                                              input.partnerId === currentUser.data.id
                                            ) {
                                              setIsModalOpen(true);
                                            } else {
                                              setCurrentSigner(input)
                                              setIsShareOpen(true);
                                            }
                                          }
                                        }}
                                        className="w-full outline-none text-gray-700 placeholder-gray-400  duration-700 ease-in-out animate-pulse-auto"
                                      >
                                        {input.id === activeInput
                                          ? input.parterName || "Signature"
                                          : "Signature"}
                                      </button>
                                    ))}
                                </div>
                              </div>
                            </Resizable>
                          </div>
                        </Draggable>
                      ))}
                    </div>
                    {uploadSuccess && (
                      <p className="text-[#4feb34] mt-2">{uploadSuccess}</p>
                    )}
                    {uploadError && (
                      <p className="text-[#ff4c30] mt-2">{uploadError}</p>
                    )}
                    {inputs.length > 0 && (
                      <div className="mt-4 flex gap-4 justify-end mr-[4rem]">
                        <button
                          onClick={() => {
                            setInputs([]);
                            setIsNext(false);
                            setUploadError(null);
                            setUploadSuccess(null);
                            setSignatureImage(null);
                          }}
                          // className="bg-[#ff4c30] hover:bg-[#ff3c20] text-white font-medium px-6 py-3 rounded-lg"
                          className="bg-[#979797] text-white px-6 py-2 rounded hover:bg-[#979797]"
                          // onClick={() => sigPad.current.clear()}
                        >
                          Annuler
                        </button>
                        <button
                          onClick={
                            signatureImage || isNext ? uploadFile : handleNext
                          }
                          // className="bg-[#ff4c30] hover:bg-[#ff3c20] text-white font-medium px-6 py-3 rounded-lg"
                          className="bg-secondary text-white px-6 py-2 rounded hover:bg-primary"
                          // onClick={uploadFile}
                          disabled={uploading}
                        >
                          {signatureImage || isNext
                            ? uploading
                              ? "Envoi en cours..."
                              : "sauvegarder"
                            : "Étape suivante"}
                        </button>
                      </div>
                    )}
                  </div>
                );
              } else {
                return (
                  <div className="w-full max-w-2xl border-2 border-dashed border-gray-300 rounded-lg p-12 flex flex-col items-center">
                    <div className="mb-6">
                      <svg
                        className="w-16 h-16 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                        />
                      </svg>
                    </div>
                    <p className="text-lg text-gray-600 mb-4">
                      Glissez et déposez ou
                    </p>
                    {selectedFile && (
                      <p className="text-blue-500 mt-2">{selectedFile.name}</p>
                    )}
                    <div className="relative">
                      <input
                        type="file"
                        onChange={handleFileChange}
                        accept=".pdf,.doc,.docx"
                        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      />
                      <button className="bg-[#ff4c30] hover:bg-[#ff3c20] text-white font-medium px-6 py-3 rounded-lg">
                        Choisir un document
                      </button>
                    </div>
                    <p className="text-sm text-gray-500 mt-4">
                      Format PDF, DOC ou DOCX. Taille maximum du fichier: 10MB
                    </p>
                    {uploading && (
                      <div className="mt-2 text-blue-500">
                        <p>Téléchargement en cours: {uploadProgress}%</p>
                        {timeRemaining && (
                          <p>Temps restant estimé: {timeRemaining} secondes</p>
                        )}
                        <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                          <div
                            className="bg-blue-600 h-2.5 rounded-full"
                            style={{ width: `${uploadProgress}%` }}
                          ></div>
                        </div>
                      </div>
                    )}
                    {uploadSuccess && (
                      <p className="text-[#4feb34] mt-2">{uploadSuccess}</p>
                    )}
                    {uploadError && (
                      <p className="text-[#ff4c30] mt-2">{uploadError}</p>
                    )}
                  </div>
                );
              }
            })()}
          </div>
        </div>
      </div>
      <EsignModal isOpen={isModalOpen} onClose={handleCloseModal}>
        <div className="border-2 border-gray-300 rounded-lg p-4 mb-4">
          <p className="text-gray-600 mb-2">Signez ici:</p>
          <SignatureCanvas
            penColor="black"
            ref={sigPad}
            canvasProps={{
              className: "sigCanvas border border-gray-200",
              style: { width: "100%", height: "200px" },
            }}
          />
        </div>
        <div className="mt-4 flex gap-4 justify-end mr-[4rem]">
          <button
            className="bg-[#979797] text-white px-6 py-2 rounded hover:bg-[#979797]"
            onClick={() => sigPad.current.clear()}
          >
            Effacer la signature
          </button>
          <button
            onClick={handleEditPdf}
            className="bg-secondary text-white px-6 py-2 rounded hover:bg-primary"
            disabled={uploading}
          >
            Étape suivante
          </button>
        </div>
      </EsignModal>
      <SignerDialog
        open={signatureUserModal}
        onClose={(e) => {
          setSignatureUserModal(false);
          if (e && activeInput) {
            // Update inputs array with the selected partner's information
            const updatedInputs = inputs.map((input) => {
              if (input.id === activeInput) {
                return {
                  ...input,
                  parterName: e.name,
                  parterEmail: e.email,
                  partnerId: e.id,
                };
              }
              return input;
            });
            setInputs(updatedInputs);
            console.log(
              "Partner assigned:",
              e.name,
              "to input ID:",
              activeInput
            );
          }
        }}
        doc_id={docId}
        user_id={currentUser.data.id}
      />
      <ActionModal
        isActionOpen={isActionOpen}
        documentData={documentData}
        selectedFile={selectedFile}
        setIsActionOpen={(e) => setIsActionOpen(e)}
        setIsModalOpen={(e) => {
          setIsDemoOpen(e);
          setIsEditing(true);
        }}
        fileType={fileType}
        setIsShareOpen={(e) => setIsShareOpen(e)}
        file={file}
        docId={docId}
        currentUser={currentUser}
      />
      <ShareDocumentModal
        isModalOpen={isShareOpen}
        setIsModalOpen={() => setIsShareOpen(false)}
        fetchDossiers={currentSigner}
        inputData={inputs}
        shareItem={{
          id: docId,
          user_id: currentUser.data.id,
        }}
      />
      <DemoGuide
        isModalOpen={isDemoOpen}
        setIsModalOpen={() => setIsDemoOpen(false)}
      />
    </Layout>
  );
};

export default SignerDesDocuments;
